export enum ReportCategory {
    IndustrialHygiene = 1,
    StationaryMonitoring = 2,
    Maintenance = 3
}